if (!customElements.get('member-price')) {
  customElements.define(
    'member-price',
    class MemberPrice extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
      }

      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          
          const variant = event.data.variant;
          this.updateMemberPrice(variant);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      formatMoney(cents) {
        // Simple money formatter - converts cents to dollars with 2 decimal places
        const dollars = (cents / 100).toFixed(2);
        return `$${dollars}`;
      }

      updateMemberPrice(variant) {
        if (!variant) {
          this.style.display = 'none';
          return;
        }

        // Update retail price property input
        this.updateRetailPriceProperty(variant);

        // Check if variant has member_price metafield (in dollars)
        const memberPriceDollars = variant?.metafields?.custom?.member_price;
        const memberPricingText = this.dataset.label;

        if (memberPriceDollars && memberPricingText) {
          // Convert dollars to cents
          const memberPriceCents = memberPriceDollars * 100;
          
          // Format the price
          const formattedPrice = this.formatMoney(memberPriceCents);
          
          // Update the display
          const labelEl = this.querySelector('.member-price__label');
          const valueEl = this.querySelector('.member-price__value');
          
          if (labelEl && valueEl) {
            labelEl.textContent = `${memberPricingText}:`;
            valueEl.textContent = formattedPrice;
            this.style.display = 'block';
            this.classList.add('member-price--visible');
          }
        } else {
          this.style.display = 'none';
          this.classList.remove('member-price--visible');
        }
      }

      updateRetailPriceProperty(variant) {
        const retailPriceInput = document.getElementById('retail-price-property');
        if (retailPriceInput && variant && variant.compare_at_price) {
          // Format the price (variant.compare_at_price is in cents)
          const formattedPrice = this.formatMoney(variant.compare_at_price);
          retailPriceInput.value = formattedPrice;
        }else if (retailPriceInput && variant && variant.price) {
          // Format the price (variant.price is in cents)
          const formattedPrice = this.formatMoney(variant.price);
          retailPriceInput.value = formattedPrice;
        }
      }
    }
  );
}

